const state = {
  setting: {}, // 问卷设置
  questionList: [] // 答题列表
}

const mutations = {
}

const actions = {
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/bot.js